module.exports = __webpack_public_path__ + "static/img/7.a104b4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/eng/7.png
// module id = di2I
// module chunks = 0